import Autocomplete from 'apollo-algolia-autocomplete';
import Nav from './Nav';
import PlaceholderGrid from './PlaceholderGrid';
import React, {useContext} from 'react';
import {SourceContext} from '../context';

import '../styles.css';
import 'apollo-algolia-autocomplete/styles.css';

// eslint-disable-next-line react/prop-types
const PageLayout = ({children}) => {
  const {docset} = useContext(SourceContext);
  let source = 'docs';

  // get value `currentSource` for autocomplete from current page location
  if (typeof window !== 'undefined') {
    let loc = window.location.pathname;

    // only need to overwrite `source` if we're not on a docs page
    if (!loc.startsWith('/docs')) {
      // remove leading and trailing slashes
      if (loc.startsWith('/')) {
        loc = loc.slice(1);
      }

      if (loc.endsWith('/')) {
        loc = loc.slice(0, loc.length - 1);
      }
      source = loc;
    }
  }

  return (
    <main style={{width: '80%', maxWidth: '760px', margin: '0 auto'}}>
      <h1 style={{textAlign: 'center'}}>{children}</h1>
      <Autocomplete
        appId={process.env.ALGOLIA_APP_ID}
        apiKey={process.env.ALGOLIA_SEARCH_KEY}
        currentSource={source}
        docset={docset}
      />
      <Nav />
      <PlaceholderGrid />
    </main>
  );
};

export default PageLayout;
